<style>
.list-group-item2 {
    position: relative;
    /* display: block; */
    padding: var(--bs-list-group-item-padding-y) var(--bs-list-group-item-padding-x);
    color: var(--bs-list-group-color);
    text-decoration: none;
    background-color: var(--bs-list-group-bg);
    border: var(--bs-list-group-border-width) solid var(--bs-list-group-border-color);
}

.modal-mb {
    position: fixed;
    background: #00000094;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
}

.modal-dialo {
    width: 80vw;
}

.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
}

.modal-content {
    background-color: white;
    padding: 20px;
    border-radius: 8px;
}
</style>
<template>
    <div class="app-layout">
        <!-- Componente de la barra de navegación -->
        <!-- Componente de la barra de navegación -->
        <NavBar :collapsed="collapsed" :pinned="pinned" @update:collapsed="updateCollapsed"
            @update:pinned="updatePinned" />
        <!-- Contenido principal -->

        <main :class="{ 'main-collapsed': collapsed, 'main-expanded': !collapsed || pinned }">
            <BarTop />
            <div class="" style="padding: 4rem;">
                <div class="py-4">
                    <div>
                        <h2 class="fw-normal mb-4 me-3"><b>{{ edit_mode ? 'Editando ' : 'Crea un ' }} cobro por servicio
                                {{ edit_mode ? '#' + edit_id : '' }}</b>
                        </h2>
                        <p>{{ edit_mode ? 'Editar' : 'Crear' }} un cobro propio de la empresa directo hacia el cliente
                            (como
                            cobros por administración), asociado a un despacho.
                        </p>
                    </div>
                    <div class="row pt-4 px-0">


                        <div class="col-4 mb-4 d-none">
                            <label for="concept" class="form-label">Seleccionar concepto</label>
                            <select class="form-select" aria-label="Default select example"
                                v-model="dataForm.concept.value">
                                <option v-for="concept in concepts" :value="concept.concept.name">{{
            concept.concept.name }}
                                </option>
                            </select>
                            <span v-if="dataForm.concept.err" class="text-danger">Debe seleccionar un concepto</span>
                        </div>
                    </div>

                    <div class="row pt-0 px-1 d-none">

                        <div class="col-2 mb-4">
                            <label for="currency" class="form-label" v-if="edit_mode">Divisa</label>
                            <label for="currency" class="form-label" v-else>Seleccionar divisa</label>

                            <select disabled class="form-select" aria-label="Default select example"
                                v-model="dataForm.currency.value"
                                @change="formatAmountAndUpdate(dataForm.amount, dataForm.currency)" v-if="edit_mode">
                                <option v-for="currency in currencies" :value="currency.id_currency">{{ currency.name }}
                                </option>
                            </select>

                            <select class="form-select" aria-label="Default select example"
                                v-model="dataForm.currency.value"
                                @change="formatAmountAndUpdate(dataForm.amount, dataForm.currency)" v-else>
                                <option v-for="currency in currencies" :value="currency.id_currency">{{ currency.name }}
                                </option>
                            </select>

                            <span v-if="dataForm.currency.err" class="text-danger">Debe seleccionar una divisa</span>
                        </div>


                    </div>

                    <div class="pt-2 px-0">
                        <div class="row pt-2 px-1">
                            <div class="col-4 mb-4">
                                <label for="client" class="form-label" v-if="edit_mode">Cliente:</label>
                                <label for="client" class="form-label" v-else>Seleccionar cliente:</label>

                                <select disabled @change="clientSelected($event)" class="form-select"
                                    aria-label="Default select example" v-model="dataForm.client.value"
                                    v-if="edit_mode">
                                    <option v-for="client in clients" :value="client.id_client">{{ client.name }}
                                    </option>
                                </select>

                                <select @change="clientSelected($event)" class="form-select"
                                    aria-label="Default select example" v-model="dataForm.client.value" v-else>
                                    <option v-for="client in clients" :value="client.id_client">{{ client.name }}
                                    </option>
                                </select>


                                <span v-if="dataForm.client.err" class="text-danger">Debe seleccionar un cliente</span>
                            </div>
                        </div>

                        <div class="row pt-2 px-1">
                            <div class="col-4 mb-4">
                                <label for="id_cs_fee_status" class="form-label">Estado</label>
                                <select class="form-select" aria-label="Default select example"
                                    v-model="dataForm.id_cs_fee_status.value"
                                    @change="statusUpdated(dataForm.id_cs_fee_status.value)">
                                    <option v-for="pstatus in allid_cs_fee_status" :value="pstatus.id_cs_fee_status">{{
            pstatus.description }}
                                    </option>
                                </select>
                                <span v-if="dataForm.id_cs_fee_status.err" class="text-danger">Debe seleccionar un
                                    estado</span>
                            </div>
                        </div>

                        <div class="row pt-2 px-1">
                            <div class="col-4 mb-4">
                                <label for="date" class="form-label">Fecha emisión factura (fecha aproximada si no se ha
                                    emitido)</label>
                                <div class="input-group mb-3">
                                    <VueDatePicker v-model="dataForm.date.value" locale="es-CL"
                                        :timezone="'America/Santiago'" format="dd/MM/yyyy HH:mm" is-24 enable-time
                                        model-type="yyyy-MM-dd'T'HH:mm:ssXXX" />
                                </div>
                                <span v-if="dataForm.date.err" class="text-danger">Debe seleccionar una fecha</span>
                            </div>
                        </div>


                        <div class="row pt-2 px-1">
                            <div class="col-4 mb-4">
                                <label for="bill" class="form-label">Número de factura</label>
                                <input
                                    :disabled="dataForm.id_cs_fee_status.value == 1 || dataForm.id_cs_fee_status.value == 2"
                                    type="text" class="form-control" :class="{ 'border-danger': dataForm.bill.err }"
                                    id="bill" placeholder="" v-model="dataForm.bill.value" @blur="handlerBlur">
                                <span v-if="dataForm.bill.err" class="text-danger">Debe ingresar un número de
                                    factura</span>
                            </div>
                        </div>
                        <div class="row pt-2 px-1">
                            <div class="col-8 mb-4">
                                <label class="form-label">Conceptos de la factura</label>

                                <!-- Línea de captura (selección + texto libre + agregar) -->
                                <div class="d-flex gap-2">
                                    <!-- Select con conceptos del cliente -->
                                    <select class="form-select" style="max-width: 320px"
                                        v-model="conceptForm.selectedId" :disabled="!clientConceptOptions.length">
                                        <option value="">(Seleccionar concepto del cliente)</option>
                                        <option v-for="opt in clientConceptOptions" :key="opt.id" :value="opt.id">
                                            {{ opt.name }}
                                        </option>
                                    </select>

                                    <button type="button" class="btn btn-outline-primary" @click="addConceptItem">
                                        Agregar
                                    </button>
                                </div>
                                <small class="text-muted">
                                    Elige un concepto. Puedes agregar varios ítems; se enviarán en
                                    orden como
                                    <em>Item 1 &ndash; Item 2 &ndash; …</em>.
                                </small>

                                <!-- Lista de ítems agregados -->
                                <ul class="list-group mt-3" v-if="dataForm.invoice_concepts.length">
                                    <li class="list-group-item d-flex justify-content-between align-items-center"
                                        v-for="(it, idx) in dataForm.invoice_concepts" :key="it.key">
                                        <span><strong>Item {{ idx + 1 }}:</strong> {{ it.text }}</span>
                                        <div class="btn-group">
                                            <button class="btn btn-sm btn-light" @click="moveConcept(idx, -1)"
                                                :disabled="idx === 0" title="Subir">
                                                <i class="bi bi-arrow-up"></i>
                                            </button>
                                            <button class="btn btn-sm btn-light" @click="moveConcept(idx, 1)"
                                                :disabled="idx === dataForm.invoice_concepts.length - 1" title="Bajar">
                                                <i class="bi bi-arrow-down"></i>
                                            </button>
                                            <button class="btn btn-sm btn-outline-danger"
                                                @click="removeConceptItem(idx)" title="Quitar">
                                                <i class="bi bi-x"></i>
                                            </button>
                                        </div>
                                    </li>
                                </ul>

                                <span v-if="dataForm.invoice_concepts_err" class="text-danger">
                                    Debes agregar al menos un concepto.
                                </span>

                                <!-- Vista previa compacta -->
                                <div class="mt-2 text-muted" v-if="dataForm.invoice_concepts.length">
                                    <small><b>Vista previa:</b> {{ conceptsInline }}</small>
                                </div>
                            </div>
                        </div>
                        <div class="row pt-4 px-1">
                            <div class="col-6 mb-4 px-3"
                                :hidden="dataForm.id_cs_fee_status.value == 1 || dataForm.id_cs_fee_status.value == 2">

                                <div v-if="dataForm2.fileName == ''">
                                    <label class="form-label mb-0">
                                        Adjuntar Factura
                                    </label>
                                    <DropFile
                                        :disabled="dataForm.id_cs_fee_status.value == 1 || dataForm.id_cs_fee_status.value == 2"
                                        @drag-end="updateFileBlob" :files="dataForm.files"
                                        v-if="dataForm2.fileName == ''" />

                                </div>

                                <span v-if="dataForm2.filerr" class="text-danger">
                                    Debe adjuntar una factura</span>


                                <div v-if="dataForm2.fileName != ''">
                                    <label for="value-cot" class="form-label mb-0">Factura adjuntada</label>
                                    <div class="text-dark row">
                                        <a class="col-3">
                                            {{ dataForm2.fileName }}</a>
                                        <div class="col-1" @click="showModal = true"><a
                                                class="dropdown-item text-primary" href="#"> <i
                                                    class="bi bi-eye px-2"></i></a></div>
                                        <div class="col-1" @click="deleteArchive()"><a class="dropdown-item text-danger"
                                                href="#"> <i class="bi bi-trash px-2"></i></a></div>
                                    </div>
                                </div>
                            </div>

                            <PreviewFile v-if="showModal" :blob="dataForm2.fileBlob" :mimeType="dataForm2.mime_type"
                                :visible="showModal" @close="showModal = false" />

                        </div>
                        <div class="row pt-4 px-1">
                            <!-- Monto neto (lo que escribe el usuario) -->
                            <div class="col-4 mb-4">
                                <label class="form-label">Monto (neto)</label>
                                <input type="text" class="form-control"
                                    :class="{ 'border-danger': dataForm.amount.err }"
                                    v-model="dataForm.amount.value_formated"
                                    @input="formatAmountAndUpdate(dataForm.amount, dataForm.currency)"
                                    @blur="handlerBlur" placeholder="Ej: 10 000" />
                                <span v-if="dataForm.amount.err" class="text-danger">Debe ingresar un monto</span>
                            </div>
                        </div>
                        <div class="row col-sm-6">

                            <div class="col-6">
                                <h4 class="mt-4 text-black">Notas de crédito / débito</h4>
                            </div>
                            <div class=" col-4 text-end pt-4">
                                <button class="btn btn-outline-primary btn-sm" @click="openNoteModal">
                                    Añadir nota
                                </button>
                            </div>

                        </div>


                        <div class="table-responsive col-sm-6">
                            <table class="table table-sm ">
                                <thead>
                                    <tr>
                                        <th>Nº Nota</th>
                                        <th>Tipo</th>
                                        <th class="">Monto</th>
                                        <th>Archivo</th>
                                        <th style="width:40px;"></th> <!-- ancho fijo para el ícono -->
                                    </tr>
                                </thead>

                                <tbody>
                                    <!-- fila vacía -->
                                    <tr v-if="notes.length === 0">
                                        <td colspan="5" class="text-center">Sin notas asociadas</td>
                                    </tr>

                                    <!-- filas con datos -->
                                    <tr v-for="(n, i) in notes" :key="i">
                                        <td>{{ n.note_number }}</td>
                                        <td class="text-capitalize">{{ n.note_type }}</td>

                                        <td class="">
                                            {{ formatCLP(n.amount) }}
                                            {{ currencyInitials }}
                                        </td>


                                        <!-- dentro de la columna Archivo -->
                                        <!-- dentro de la columna Archivo -->
                                        <td>
                                            <a class="" v-if="n.id_cs_fee_note"
                                                @click.prevent="openNoteFile(n.id_cs_fee_note, n.mime_type)"> <i
                                                    class="bi bi-eye px-2"></i></a>

                                            <PreviewFile v-if="showModalFile" :blob="formFile.blobFile"
                                                :mimeType="formFile.mimetype" :visible="showModalFile"
                                                @close="showModalFile = false" />
                                        </td>

                                        <td class="text-center">
                                            <i class="bi bi-trash text-danger" role="button"
                                                @click="notes.splice(i, 1)"></i>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <!-- Modal Añadir Nota -->
                        <div v-if="showNoteModal" class="modal-mb">
                            <div class="modal-dialog bg-white">
                                <div class="modal-content p-4">

                                    <h5>Añadir nota</h5>

                                    <div class="row g-3 mt-2">
                                        <!-- tipo -->
                                        <div class="col-4">
                                            <label class="form-label">Tipo</label>
                                            <select class="form-select" v-model="noteForm.note_type">
                                                <option value="credit">Crédito (-)</option>
                                                <option value="debit">Débito (+)</option>
                                            </select>
                                        </div>

                                        <!-- número -->
                                        <div class="col-4">
                                            <label class="form-label">Nº nota</label>
                                            <input type="text" class="form-control" v-model="noteForm.note_number"
                                                :class="{ 'border-danger': noteFormErr.note_number }" />
                                        </div>

                                        <!-- monto -->
                                        <div class="col-4">
                                            <label class="form-label">Monto neto</label>

                                            <input type="text" class="form-control"
                                                :class="{ 'border-danger': noteFormErr.amount }"
                                                v-model="noteForm.amount.value_formated"
                                                @input="formatAmountAndUpdate(noteForm.amount, dataForm.currency)"
                                                placeholder="Ej: 10 000" />
                                        </div>


                                        <!-- adjunto -->
                                        <div class="col-12">
                                            <label class="form-label">Adjuntar archivo (PDF / imagen)</label>
                                            <input type="file" class="form-control" @change="handleNoteFile" />
                                        </div>
                                    </div>

                                    <!-- botones -->
                                    <div class="mt-4 text-end">
                                        <div class="text-end" v-if="dataForm.currency.value === 15">
                                            <p class="form-label">Monto con IVA:
                                                {{ formatCLP((noteForm.amount.value * 0.19).toFixed(2)) }}</p>
                                        </div>
                                        <div class="text-end">
                                            <p class="form-label">TOTAL:
                                                <span v-if="dataForm.currency.value === 15"> {{ formatCLP(
            (noteForm.amount.value * 1.19).toFixed(2)) }}</span>
                                                <span v-else> {{ noteForm.amount.value }}</span>
                                            </p>
                                        </div>
                                        <button class="btn btn-secondary me-2" @click="saveNote">Guardar</button>
                                        <button class="btn btn-outline-secondary"
                                            @click="closeNoteModal">Cancelar</button>
                                    </div>

                                </div>
                            </div>
                        </div>
                        <div class="text-black">
                            <p class="mb-0 text-black">
                                <b>Total con notas:</b>
                                {{ formatCLP(totalWithNotes) }} {{ currencyInitials }}
                            </p>

                            <!-- SOLO mostrar si la divisa es CLP -->
                            <template v-if="dataForm.currency.value === 15">
                                <p class="mb-0 text-black">
                                    <b>Valor IVA (19&nbsp;%):</b>
                                    {{ formatCLP(ivaAmount) }} {{ currencyInitials }}
                                </p>

                                <p class="text-black">
                                    <b>Total con IVA:</b>
                                    {{ formatCLP(totalWithIva) }} {{ currencyInitials }}
                                </p>
                            </template>
                        </div>
                        <div class="mt-3">
                            <h4 class="text-black">Despachos</h4>
                        </div>
                        <span v-if="dataForm.noShippingErr" class="text-danger">
                            Debe asociar un despacho</span>
                        <div class="text-dark" v-if="dataForm3.isShipping">
                            <div>Este pago está asociado a los siguientes despachos:</div>
                            <ul class="mt-2">
                                <li v-for="s in dataForm3.selectedShippings" :key="s.id_shipping">
                                    Numero despacho: {{ s.shipping_number }}
                                </li>
                            </ul>
                        </div>
                        <div class="text-end pb-2">
                            <button class="btn btn-outline-secondary btn-sm"
                                @click="dataForm3.selectedShippings = []; dataForm3.isShipping = false">
                                Limpiar selección
                            </button>
                        </div>

                        <vue3-datatable :search="search" :rows="shippings" :columns="columns" order :sortable="true"
                            :sortColumn="'date'">
                            <template #select="data">
                                <button @click="toggleSelectionShipping(data.value)">
                                    {{ isSelectedShipp(data.value) ? 'Desasociar' : 'Asociar' }}
                                </button>
                            </template>
                            <template #amount="data">
                                <p>{{ data.value.amount }} <strong>{{ data.value.initials }}</strong></p>
                            </template>
                            <template #client="data">
                                <p>{{ data.value.client.name }} </p>
                            </template>
                            <template #currency="data">
                                <p>{{ data.value.currency.initials }}</p>
                            </template>
                        </vue3-datatable>

                        <div class="text-center text-lg-end mt-4 pt-2">

                            <button type="button" class="btn btn-md text-white mx-2" v-if="!edit_mode"
                                style="padding-left: 2.5rem; padding-right: 2.5rem;background-color: #5a50e0;"
                                @click="create()">
                                Crear
                            </button>
                            <button type="button" class="btn btn-md text-white mx-2" v-if="edit_mode"
                                style="padding-left: 2.5rem; padding-right: 2.5rem;background-color: #5a50e0;"
                                @click="edit()">
                                Editar
                            </button>
                            <button type="button" class="btn btn-md text-white bg-danger" @click="cancel()"
                                style="padding-left: 2.5rem; padding-right: 2.5rem;background-color: #5a50e0;">
                                Cancelar
                            </button>
                        </div>

                    </div>
                </div>
            </div>

        </main>
        <PreviewFile v-if="showModal" :blob="dataForm2.fileBlob" :mimeType="dataForm2.mime_type" :visible="showModal"
            @close="showModal = false" />
    </div>
</template>
<script>
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';
import DropFile from './../../component/DropFile.vue';
import DataTable from "datatables.net-vue3";
import DataTablesCore from "datatables.net";
import NavBar from './../../component/NavBar.vue';
import BarTop from './../../component/BarTop.vue';
import PreviewFile from './../../component/PreviewFile.vue';
import NumUtils from '../../component/NumUtils.vue';
import Vue3Datatable from "@bhplugin/vue3-datatable";

import { formatInTimeZone } from 'date-fns-tz';
const TZ_CL = 'America/Santiago';
DataTable.use(DataTablesCore);

export default {
    components: {
        VueDatePicker,
        DataTable,
        VueDatePicker,
        DropFile,
        DataTablesCore,
        NavBar,
        PreviewFile,
        BarTop,
        NumUtils,
        Vue3Datatable
    },
    data() {
        return {
            collapsed: true,
            edit_mode: false,
            edit_id: 0,
            notes: [],            // ← solo front hasta guardar
            noteForm: {
                note_type: 'credit', note_number: '', amount: {
                    value: 0,
                    value_formated: '',
                }, file: null, filename: ''
            },
            noteFormErr: {},
            showNoteModal: false,
            verShipping: false,
            showModal: false,
            pinned: localStorage.getItem('pinned') == 'false' ? false : true || false,
            theme: localStorage.getItem('theme') || 'light-mode',
            currencies: [],
            concepts: [],
            allid_cs_fee_status: [],
            clients: [],
            formFile: {},
            showModalFile: false,
            paymentMethodes: [
                {
                    id: 1,
                    name: 'Transferencia electronica',

                },
                {
                    id: 2,
                    value: 'Pago tarjeta de credito',

                }, {
                    id: 3,
                    value: 'Pago en efectivo',

                },
            ],
            conceptForm: {
                selectedId: '',
                customText: ''
            },
            //idClient: 0,
            dataForm: {
                sending: false,
                // newBill: true,
                noShippingErr: false,
                invoice_concepts: [],        // [{ key, id, name, text }]
                invoice_concepts_err: false, // flag de validación opcional
                id_cs_fee_status: {
                    value: '',
                    err: false,
                },

                client: {
                    value: '',
                    err: false
                },
                date: {
                    value: '',
                    err: false
                },
                amount: {
                    value: '',
                    value_formated: '',
                    err: false
                },
                amount_iva: {
                    value: 0,             // numérico puro (neto + 19 %)
                    value_formated: '',   // string sólo para mostrar
                },
                currency: {
                    value: 15,
                    err: false
                },
                concept: {
                    value: 'Costo operacional',
                    err: false
                },
                bill: {
                    value: '',
                    err: false
                },

                isShipping: false,
                files: []
            },
            shippings: [

            ],
            dataForm2: {
                fileName: '',
                mime_type: '',
                file: '',
                filerr: false,
                fileBlob: null
            },
            dataForm3: {
                isShipping: false,
                shippingSelect: {},
                selectedShippings: [],
            },
            columns: [
                { field: 'select', title: 'Seleccionar' },
                { field: "shipping_number", title: "Número Despacho" },
                { field: "date_shipping", title: "Fecha" },
                { field: "week", title: "Semana" },
                { field: "boarding_number", title: "Número de embarque" },
                { field: "total_container", title: "Número de contenedores" },
                { field: "booking_number", title: "Número de reserva" },
                { field: "type_operation", title: "Tipo operación" },
                { field: "consignee", title: "Despachador" },
                { field: "port_departure_shipment", title: "Puerto de embarque" },
                { field: "country_destination", title: "País destino" }
            ],
        }
    },
    async mounted() {
        document.body.className = this.theme;
        let sessionData = localStorage.getItem('user');
        this.user = JSON.parse(sessionData);
        let urlpath = window.location.pathname;
        this.edit_mode = false;
        this.edit_id = 0;
        let parts = urlpath.split('/');
        if (parts.length == 3) {
            if (!isNaN(Number(parts[2]))) {
                this.edit_id = Number(parts[2]);
                this.edit_mode = true
            }
        }

        this.$swal({
            title: 'Cargando...',
            showConfirmButton: false,
            showCancelButton: false
        });
        this.$swal.showLoading();

        await this.getCurrencies();

        await this.getClients();
        await this.getAllidCsFeeStatus();

        let editError = false;
        if (this.edit_mode) {
            await this.getService(this.edit_id);
            await this.fetchNotes();
        }

        this.$swal.close();

    },
    computed: {
        totalWithNotes() {
            const ajuste = this.notes.reduce(
                (s, n) => s + (n.note_type === 'credit' ? -Number(n.amount) : Number(n.amount)), 0
            )
            return Number(this.dataForm.amount.value || 0) + ajuste
        },
        toChileISO(dateLike) {
            const d = dateLike instanceof Date ? dateLike : new Date(dateLike);
            // Pasamos el instante a la zona de Chile (maneja DST automáticamente)
            const zoned = utcToZonedTime(d, TZ_CL);
            // Formato ISO con offset (XXX = -03:00 / -04:00)
            return format(zoned, "yyyy-MM-dd'T'HH:mm:ssXXX", { timeZone: TZ_CL });
        },
        ivaAmount() {
            // si la divisa NO es CLP, IVA = 0
            if (this.dataForm.currency.value !== 15) return 0
            return +(this.totalWithNotes * 0.19).toFixed(2)
        },

        totalWithIva() {
            return this.totalWithNotes + this.ivaAmount
        },
        clientConceptOptions() {
            // Normaliza distintas formas posibles que pueda traer tu API
            return (this.concepts || []).map((c, i) => ({
                id:
                    c.id_client_concept ??
                    c.client_concept_id ??
                    c.id ??
                    c.concept?.id ??
                    i, // fallback
                name:
                    c.name ??
                    c.concept?.name ??
                    c.concept?.concept?.name ??
                    c.description ??
                    c.title ??
                    'Concepto',
            }));
        },
        conceptsInline() {
            return this.dataForm.invoice_concepts
                .map((it, idx) => `Item ${idx + 1} ${it.text}`)
                .join(' – ');
        }
    },
    methods: {
        uniqueKey() {
            return `${Date.now()}-${Math.random().toString(16).slice(2)}`;
        },

        addConceptItem() {
            const fromSelect = this.clientConceptOptions.find(o => o.id == this.conceptForm.selectedId);
            const text = (this.conceptForm.customText || '').trim() || fromSelect?.name || '';

            if (!text) {
                this.$swal?.fire('Atención', 'Debes seleccionar un concepto.', 'info');
                return;
            }

            this.dataForm.invoice_concepts.push({
                key: this.uniqueKey(),
                id: fromSelect?.id ?? null,   // id del concepto del cliente (si aplica)
                name: fromSelect?.name ?? '', // nombre original (si aplica)
                text                           // texto final que se mostrará
            });

            // limpiar inputs
            this.conceptForm.selectedId = '';
            this.conceptForm.customText = '';
            this.dataForm.invoice_concepts_err = false;
        },

        removeConceptItem(idx) {
            this.dataForm.invoice_concepts.splice(idx, 1);
        },

        moveConcept(idx, dir) {
            const j = idx + dir;
            if (j < 0 || j >= this.dataForm.invoice_concepts.length) return;
            const arr = this.dataForm.invoice_concepts;
            [arr[idx], arr[j]] = [arr[j], arr[idx]];
            // forzar reactividad si quieres:
            this.dataForm.invoice_concepts = [...arr];
        },
        buildInvoiceFlags() {
            const hasNew = this.dataForm.files.length > 0          // arrastró uno nuevo
            const hasOld = !!this.dataForm2.fileBlob               // ya existía adjunto
            const remove = !hasNew && !hasOld                      // lo quitó

            return {
                update_doc: hasNew || remove ? 1 : 0,
                delete_doc: remove ? 1 : 0,
                file: hasNew ? this.dataForm.files[0] : null
            }
        },

        /* ▸ NOTAS – payload ****************************************** */
        buildNotesPayload() {
            return this.notes.map((n, i) => ({
                id_cs_fee_note: n.id_cs_fee_note ?? null,           // viene en edición
                note_type: n.note_type,
                note_number: n.note_number,
                amount: n.amount,
                id_currency: this.dataForm.currency.value,
                file_key: n.file ? `note_file_${i}` : null    // clave si hay archivo
            }))
        },
        validateForm() {
            // limpia flags
            this.dataForm.id_cs_fee_status.err = false
            this.dataForm.date.err = false
            this.dataForm.bill.err = false
            this.dataForm.amount.err = false
            this.dataForm2.filerr = false
            // this.dataForm.noShippingErr = false // si luego quieres exigir al menos 1 shipping

            const missing = []

            // 1) Estado
            const statusVal = this.dataForm.id_cs_fee_status.value
            if (!statusVal) {
                this.dataForm.id_cs_fee_status.err = true
                missing.push('Estado')
            }

            // 2) Fecha emisión
            const dateVal = this.dataForm.date.value
            const isValidDate = dateVal && !isNaN(new Date(dateVal).getTime())
            if (!isValidDate) {
                this.dataForm.date.err = true
                missing.push('Fecha de emisión de factura')
            }
            // exigir al menos un concepto
            if ((this.dataForm.invoice_concepts || []).length === 0) {
                this.dataForm.invoice_concepts_err = true;
                missing.push('Conceptos de la factura');
            }
            // 3) Monto neto (> 0)
            const amountNum = Number(this.dataForm.amount.value)
            if (!amountNum || isNaN(amountNum) || amountNum <= 0) {
                this.dataForm.amount.err = true
                missing.push('Monto neto')
            }

            // 4) Nº factura y archivo (solo si estado ≠ 1 y ≠ 2)
            const needsInvoice = !(statusVal == 1 || statusVal == 2)
            if (needsInvoice) {
                if (!this.dataForm.bill.value) {
                    this.dataForm.bill.err = true
                    missing.push('Número de factura')
                }
                const hasNew = (this.dataForm.files || []).length > 0
                const hasOld = !!this.dataForm2.fileBlob
                if (!(hasNew || hasOld)) {
                    this.dataForm2.filerr = true
                    missing.push('Archivo de factura')
                }
            }

            // 5) (Opcional) exigir al menos un shipping:
            // if ((this.dataForm3.selectedShippings || []).length === 0) {
            //   this.dataForm.noShippingErr = true
            //   missing.push('Al menos un despacho')
            // }

            if (missing.length) {
                this.$swal.fire({
                    icon: 'warning',
                    title: 'Faltan campos obligatorios',
                    html: `<ul style="text-align:left;margin:0">${missing.map(m => `<li>${m}</li>`).join('')}</ul>`
                })
                return false
            }
            return true
        },
        /* ▸ ENVÍO genérico (crear / editar) ************************* */
        sendForm(isEdit = false) {
            console.log(new Date(this.dataForm.date.value).toISOString());
            const d = this.dataForm.date.value;      // Date real

            // ✅ 1) Validar antes de armar el payload
            if (!this.validateForm()) return
            const fd = new FormData()
            const inv = this.buildInvoiceFlags()
            const formattedDate = formatInTimeZone(d, TZ_CL, "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'");

            const selectedIds = (this.dataForm3.selectedShippings || []).map(s => s.id_shipping)

            fd.append('id_shippings', JSON.stringify(selectedIds));
            /* ---- campos base ---- */
            const body = {
                ...inv,
                date_fee: formattedDate,
                amount: this.dataForm.amount.value,
                id_currency: this.dataForm.currency.value,
                concept: this.dataForm.concept.value,
                bill_number: this.dataForm.bill.value,
                invoice_concepts: JSON.stringify(
                    (this.dataForm.invoice_concepts || []).map((it, idx) => ({
                        order: idx + 1,
                        id_client_concept: it.id, // puede ser null si fue texto libre
                        label: it.text
                    }))
                ),
                id_cs_fee_status: this.dataForm.id_cs_fee_status.value,
                id_client: this.dataForm.client.value,

                notes: JSON.stringify(this.buildNotesPayload()),
                ...(isEdit ? { id_cs_fee: this.edit_id } : {})
            }

            /* ---- pasar todo a FormData ---- */
            Object.entries(body).forEach(([k, v]) => {
                if (v !== null && v !== undefined) fd.append(k, v)
            })

            /* ---- adjuntar archivos de notas ---- */

            this.notes.forEach((n, i) => {
                if (n.file) fd.append(`note_file_${i}`, n.file)
            })
            const url = isEdit ? '/api/updateCsFee' : '/api/cs-fees'
            console.log(fd);
            axios.post(url, fd, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('accessToken')}`
                }
            }).then(() => window.location.href = '/serviciosCobrar')
        },

        /* wrappers para el UI */
        create() { this.sendForm(false); },
        edit() { this.sendForm(true); },
        /* ---------- helper para CLP ---------- */
        formatCLP(val, currencyCode = 'CLP') {
            if (val === null || val === undefined) return ''
            return new Intl.NumberFormat('es-CL', {
                style: 'currency',
                currency: currencyCode,
                minimumFractionDigits: 0,
            }).format(val)
        },
        openNoteModal() {
            this.noteForm = {
                note_type: 'credit', note_number: '', amount: {
                    value: 0,
                    value_formated: ''
                }, file: null, filename: ''
            };

            this.noteFormErr = {}
            this.showNoteModal = true
        },
        closeNoteModal() {
            this.showNoteModal = false
        },

        /* helper opcional para cargar archivo */
        handleNoteFile(e) {
            const f = e.target.files[0] || null
            this.noteForm.file = f
            this.noteForm.filename = f ? f.name : ''
        },
        /* guarda la nota y refresca la lista */
        saveNote() {
            /* validaciones mínimas */
            this.noteFormErr = {}
            if (!this.noteForm.note_number) this.noteFormErr.note_number = true
            if (!this.noteForm.amount.value) this.noteFormErr.amount = true
            if (Object.keys(this.noteFormErr).length) return

            /* 1️⃣  Clonar nota (evitar reactividad sobre el modal) */
            const n = { ...this.noteForm }
            /* 2️⃣  Generar URL local si hay archivo – para botón “Ver” */
            if (n.file) n.blob_url = URL.createObjectURL(n.file)

            /* 3️⃣  Guardar en array y cerrar modal */
            n.amount = this.noteForm.amount.value;
            this.notes.push(n)
            this.showNoteModal = false
        },
        async openNoteFile(id, mimetype) {
            this.$swal({
                title: 'Cargando...',
                showConfirmButton: false,
                showCancelButton: false
            });
            this.$swal.showLoading();
            try {
                /* Pedimos el blob directamente; Axios necesita responseType:'blob' */
                const { data: blob } = await axios.get(
                    `/api/cs-fee-notes/${id}/file`,
                    {
                        responseType: 'blob',
                        headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` }
                    }
                );

                /* Creamos URL temporal y la abrimos */
                // const url = URL.createObjectURL(blob);
                //window.open(url, '_blank');
                console.log(mimetype);
                this.$swal.close();
                this.formFile.blobFile = blob;
                this.formFile.mimetype = mimetype;
                this.showModalFile = true;


            } catch (err) {
                console.error(err);
                this.$swal.fire({
                    icon: 'error',
                    title: 'No se pudo abrir la nota',
                    text: 'Compruebe su conexión o contacte a soporte.'
                });
            }
        },
        async fetchNotes() {
            this.$swal.update({ title: 'Cargando Notas de credito/debito...' });
            this.$swal.showLoading();
            const { data } = await axios.get(`/api/cs-fees/${this.edit_id}/notes`, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('accessToken')}`
                }
            });
            this.notes = data

            setTimeout(() => {
                this.$swal.close();
                // Cierra el modal después de 3 segundos
            }, 1000);

        },
        updateFileBlob() {
            let newFile = this.dataForm.files[0];
            this.dataForm2.fileName = newFile["name"];
            this.dataForm2.mime_type = newFile["type"];
            this.dataForm2.fileBlob = this.dataForm.files[0];
            this.dataForm2.filerr = false;
        },

        formatAmountAndUpdate(amountInput, currencySelect) {
            console.log(amountInput);
            NumUtils.methods.formatAmountAndUpdate(amountInput, currencySelect);
        },

        statusUpdated(id_status) {
            // estado borrador o factura no emitida
            if (id_status == 1 || id_status == 2) {
                // this.dataForm.date.value = "";
                this.dataForm.bill.value = "";
                this.dataForm2.fileName = "";
                this.dataForm2.fileBlob = null;
                this.dataForm.files = [];
                this.dataForm.files.splice(0); // borrar todo
                // this.dataForm.date.err = false;
                this.dataForm.bill.err = false;
                this.dataForm2.filerr = false;

            }

        },


        async getAllidCsFeeStatus() {

            const self = this;

            try {
                const response = await axios.get('/api/cs-fee-statuses', {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem('accessToken')}`
                    }
                });
                this.allid_cs_fee_status = response.data;
            } catch (error) {
                console.error('Error fetching currencies:', error);
                self.$swal.fire({
                    icon: "error",
                    title: "Error interno",
                    text: "Comuníquese con soporte.",
                    showConfirmButton: true,
                    showCancelButton: false
                });
            }
        },

        isSelectedShipp(row) {
            console.log(row);
            console.log(this.dataForm3.selectedShippings);
            return this.dataForm3.selectedShippings
                .some(s => s.id_shipping === row.id_shipping)
        },
        base64ToBlob(base64, contentType, sliceSize = 512) {
            const byteCharacters = atob(base64);
            const byteArrays = [];

            for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
                const slice = byteCharacters.slice(offset, offset + sliceSize);
                const byteNumbers = new Array(slice.length);
                for (let i = 0; i < slice.length; i++) {
                    byteNumbers[i] = slice.charCodeAt(i);
                }
                const byteArray = new Uint8Array(byteNumbers);
                byteArrays.push(byteArray);
            }

            return new Blob(byteArrays, { type: contentType });
        },

        async getService(id) {
            this.$swal.update({ title: 'Cargando data de servicio por cobrar...' });
            this.$swal.showLoading();

            try {
                const response = await axios.get(`/api/services-to-be-collected/${id}/includefile`, {
                    headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` }
                });

                if (response.status !== 200) return;

                const data = response.data.data;

                // Campos base (tal como ya los tienes)
                this.dataForm.client.value = data.id_client;
                this.dataForm.currency.value = data.id_currency;

                const d = data.date_origin;      // Date real

            

                this.dataForm.date.value = formatInTimeZone(d, TZ_CL, "yyyy-MM-dd'T'HH:mm:ssXXX");

                console.log(this.dataForm.date.value);
                this.dataForm.amount.value = data.amount;
                this.dataForm.id_cs_fee_status.value = data.id_status;

                const amounts = NumUtils.methods.formatAmount(data.amount, data.id_currency);
                if (amounts['value'] != null) {
                    this.dataForm.amount.value = amounts['value'];
                    this.dataForm.amount.value_formated = amounts['value_formated'];
                }

                this.dataForm.concept.value = data.concept;
                this.dataForm.bill.value = data.bill_number;

                if (data.file) {
                    this.dataForm2.fileName = data.filename;
                    this.dataForm2.mime_type = data.mime_type;
                    this.dataForm2.fileBlob = this.base64ToBlob(data.file, data.mime_type, 512);
                }

                // 🔹 Asegura que en edición cargamos los conceptos del cliente (para el <select>)
                this.getConcepts(data.id_client, true);

                // 🔹 Poblar invoice_concepts como al crear
                //    (intenta leer de response.data.invoice_concepts, o data.invoice_concepts)
                const invRaw = response.data.invoice_concepts ?? data.invoice_concepts ?? [];
                const invArr = typeof invRaw === 'string' ? JSON.parse(invRaw) : invRaw;

                if (Array.isArray(invArr) && invArr.length) {
                    this.dataForm.invoice_concepts = invArr
                        .sort((a, b) => (a.order ?? a.item_order ?? a.sequence ?? 0) - (b.order ?? b.item_order ?? b.sequence ?? 0))
                        .map(it => ({
                            key: this.uniqueKey(),
                            id: it.id_client_concept ?? it.client_concept_id ?? it.id ?? null,
                            name: it.name ?? it.client_concept?.name ?? it.label ?? '',
                            text: it.label ?? it.text ?? it.name ?? ''
                        }));
                } else if (data.concept) {
                    // Fallback: si el registro viejo no tenía items, al menos muestra el concepto único
                    this.dataForm.invoice_concepts = [{
                        key: this.uniqueKey(),
                        id: null,
                        name: '',
                        text: data.concept
                    }];
                } else {
                    this.dataForm.invoice_concepts = [];
                }
                this.dataForm.invoice_concepts_err = false;

                // Despachos (como ya lo haces)
                await this.getShippingEdit(data.id_client);
                console.log(response.data.shippings);
                const shps = response.data.shippings || [];
                this.dataForm3.selectedShippings = shps;
                console.log(this.dataForm3.selectedShippings);
                this.dataForm3.isShipping = shps.length > 0;

                this.$swal.close();
            } catch (error) {
                console.log(error);
                if (error?.response?.statusText === 'Unauthorized') {
                    localStorage.removeItem('accessToken');
                    window.location.href = './../../api/auth/logout';
                } else {
                    this.$swal.fire({
                        icon: "error",
                        title: "Error interno 1.1",
                        text: "Comuníquese con soporte.",
                        showConfirmButton: true,
                        showCancelButton: false
                    });
                }
            }
        },
        toggleSelectionShipping(row) {
            const idx = this.dataForm3.selectedShippings
                .findIndex(s => s.id_shipping === row.id_shipping)

            if (idx !== -1) {
                // desasociar
                this.dataForm3.selectedShippings.splice(idx, 1)
            } else {
                // asociar
                this.dataForm3.selectedShippings.push(row)
            }

            // flag de ayuda para validaciones/UX
            this.dataForm3.isShipping = this.dataForm3.selectedShippings.length > 0
            if (this.dataForm3.isShipping) this.dataForm.noShippingErr = false
        },

        async getClients() {

            const self = this;

            await axios.get('/api/clients', {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('accessToken')}`
                }
            }).then(response => {
                if (response.status == 200) {
                    self.clients = response.data.filter((client) => client.status == 1);
                } else {
                    self.clients = [];
                }
            }).catch(function (error) {

                if (error.response.statusText == 'Unauthorized') {
                    localStorage.removeItem('accessToken');
                    window.location.href = './../../api/auth/logout'
                }
            });

        },

        async getConcepts(idClient, edit) {

            const self = this;

            try {

                /* asociaciones del cliente */
                const response = await axios.get(`/api/clients/${idClient}/concepts`, {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem('accessToken')}`
                    }
                });
                this.concepts = response.data;
                if (this.concepts.length == 0) {
                    this.$swal({
                        title: "No tienes conceptos agregados",
                        text: "Debes ingresar un concepto para generar un servicio por cobrar",
                        showDenyButton: false,
                        cancelButtonText: 'Agregar concepto'
                    }).then((result) => {
                        /* Read more about isConfirmed, isDenied below */
                        window.location.href = '/clientes/concept/' + idClient;

                    });
                } else {
                    if (!edit) {
                        self.getShipping();
                    }

                }
            } catch (error) {
                console.error('Error fetching concepts:', error);
            }
        },
        deleteArchive() {
            const self = this;
            self.$swal.fire({
                icon: "question",
                title: "Estas seguro que deseas quitar este archivo adjunto?",
                showConfirmButton: true,
                confirmButtonText: "Si, eliminar",
                cancelButtonText: "No, conservar",
                showCancelButton: true
            }).then((result) => {
                if (result.isConfirmed) {
                    // this.dataForm.newBill = true;
                    this.dataForm2.fileName = "";
                    this.dataForm2.fileBlob = null;
                    this.dataForm.files = [];
                    this.dataForm.files.splice(0); // borrar todo
                }
            });
        },
        async clientSelected(value) {
            //console.log('Selected Option:', value);
            this.selectedOption = value;
            const self = this;
            let idclient = self.dataForm.client.value;
            await this.getConcepts(idclient, false);

        },
        getShippingEdit(idclient) {
            const self = this;
            const req = {
                page: 1,
                per_page: 1000,
                id_client: idclient
            }
            axios.post('/api/getShippings', req, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('accessToken')}`
                }
            }).then(response => {
                if (response.status == 200) {
                    self.shippings = response.data.data;


                } else {
                    self.shippings = [];
                }
            }).catch(function (error) {

                if (error.response.statusText == 'Unauthorized') {
                    localStorage.removeItem('accessToken');
                    window.location.href = './../../api/auth/logout'
                }


            });
        },

        getShipping() {
            const self = this;

            let idclient = 0;

            if (self.dataForm.client.value == "") {
                self.shippings = []
                self.dataForm3.isShipping = false
                self.dataForm3.selectedShippings = []
                return
            } else {
                idclient = self.dataForm.client.value;
                self.dataForm3.isShipping = false
                self.dataForm.noShippingErr = false
                self.dataForm3.selectedShippings = []
            }
            const req = {
                page: 1,
                per_page: 10000,
                id_client: idclient
            }

            axios.post('/api/getShippings', req, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('accessToken')}`
                }
            }).then(response => {

                if (response.status == 200) {

                    self.shippings = response.data.data;
                } else {
                    self.shippings = [];
                }
            }).catch(function (error) {

                if (error.response.statusText == 'Unauthorized') {
                    localStorage.removeItem('accessToken');
                    window.location.href = './../../api/auth/logout'
                }


            });
        },
        cancel() {
            window.location.href = './../serviciosCobrar';
        },

        async getCurrencies() {
            try {
                const response = await axios.get('/api/currencies', {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem('accessToken')}`
                    }
                });
                this.currencies = response.data.filter((divisa) => {
                    return divisa.status == 1
                });
            } catch (error) {
                console.error('Error fetching currencies:', error);
            }
        },
        closeModal() {
            const self = this;
            self.verShipping = false;
        },
        updateCollapsed(value) {
            //  console.log('Evento recibido:', value); // Para depuración
            this.collapsed = value; // Actualiza el estado
        },
        updatePinned(value) {
            // console.log('Evento recibido pinn:', value); // Para depuración
            this.pinned = value; // Actualiza el estado
        },
        showreq(id) {
            const self = this;
            // console.log(id);
        }
    },
};
</script>

<style lang="css">
@import 'bootstrap';
@import 'datatables.net-bs5';

body {
    background-color: #f2f5f9;
}

.cont-proveedor {
    height: 300px;
    overflow-y: scroll;
}
</style>